import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"
import { useGraphite } from "@/components/Graphite"

const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
)

// Graphite's field label: the body face at 12px, medium weight
const graphiteLabel = "text-sm font-medium leading-normal peer-disabled:cursor-not-allowed peer-disabled:opacity-40"

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(useGraphite() ? graphiteLabel : labelVariants(), className)} {...props} />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
